/**
 * Fire a GA4 event. A no-op on the server, in tests without gtag, and when
 * the tag is blocked, so callers never need to guard.
 *
 * Event names used by the static pages (registered as GA4 key events by the
 * owner): suburb_view, agent_view, watch_cta_click, nearby_click,
 * agent_link_click, methodology_view.
 */
export function track(eventName, params = {}) {
  if (typeof window === 'undefined' || typeof window.gtag !== 'function') return;
  try {
    window.gtag('event', eventName, params);
  } catch (error) {
    // Analytics must never break the page.
  }
}

export default track;
